import { useTranslation } from 'react-i18next'
import type { DownloadProfile, MediaRoot } from '../lib/api'
import { DownloadProfileSummary } from './DownloadProfileSummary'

interface Props {
  profiles: DownloadProfile[]
  roots: MediaRoot[]
  value: string | null
  loading?: boolean
  onSelect: (profile: DownloadProfile) => void
  className?: string
}

export function DownloadProfileField({ profiles, roots, value, loading = false, onSelect, className = '' }: Props) {
  const { t } = useTranslation()
  const activeProfiles = profiles.filter((profile) => profile.active)
  const selectedProfile = activeProfiles.find((profile) => profile.id === value)

  return <label className={`field ${className}`.trim()}>
    <span>{t('downloadDialog.profile')}</span>
    <select
      value={selectedProfile?.id ?? ''}
      disabled={loading || activeProfiles.length === 0}
      onChange={(event) => {
        const profile = activeProfiles.find((item) => item.id === event.target.value)
        if (profile) onSelect(profile)
      }}
    >
      {!selectedProfile && <option value="" disabled>{loading ? t('common.loading') : t('profiles.noActive')}</option>}
      {activeProfiles.map((profile) => <option key={profile.id} value={profile.id}>{profile.name}</option>)}
    </select>
    <DownloadProfileSummary profile={selectedProfile} roots={roots} />
  </label>
}
